module.exports = __webpack_public_path__ + "img/HOSPITALISATION_ACTIVE.4b7dbee1.svg";